import { useAppSelector } from "@redux/hooks";
import { isReservationsEnabledSelector } from "@redux/features/auth/authSlice";

/**
 * Hook to check if the reservations feature is enabled for the current company.
 * 
 * @returns {boolean} True if reservations are enabled, false otherwise.
 */
export function useIsReservationsEnabled(): boolean {
    return useAppSelector(isReservationsEnabledSelector);
}
